import { getFormValues } from 'redux-form';
import { merge, omit } from 'lodash';
import type { IOrganizationIntegrations } from 'types/organization';
import { FORM_MODEL } from 'admin/constants/common';

export const createStoryFormValuesSelector = getFormValues(FORM_MODEL.CREATE_STORY);

/**
 * Template integrations win over story (organization) ones. Custom tracker fields depend on each other
 * (url + loading method), so template custom tracker replaces the story one as a whole.
 * Returns a new object: `integrations` may come from the store.
 */
export const mergeTemplateIntegrations = (
	integrations: IOrganizationIntegrations | undefined,
	templateIntegrations: IOrganizationIntegrations | undefined
): IOrganizationIntegrations => {
	const result: IOrganizationIntegrations = merge({}, integrations, omit(templateIntegrations, 'customTracker'));

	if (templateIntegrations?.customTracker?.customTrackerUrl) {
		result.customTracker = templateIntegrations.customTracker;
	}

	return result;
};
